import { Button, Kind } from '@thanx/uikit/button'
import checkoutMessagePreview from 'assets/images/cms/checkout-message-preview.svg'
import InfoBox from 'components/InfoBox'
import { buildTranslate } from 'locales'
import React from 'react'
import CmsPage from 'scenes/Cms/components/CmsPage'

const t = buildTranslate('cms.checkout_message')

type Props = {
  canEdit: boolean
  isLoading: boolean
  onAdd: () => void
  showTitle?: boolean
}

const EmptyState: React.FC<Props> = ({
  canEdit,
  isLoading,
  onAdd,
  showTitle = true,
}) => {
  return (
    <CmsPage
      showTitle={showTitle}
      title={t('title')}
      description={t('description')}
      isLoading={isLoading}
    >
      <InfoBox type="tip" content={t('add_description')} className="mb-m" />
      <div className="text-center mb-m">
        <img
          src={checkoutMessagePreview}
          alt={t('image_alt')}
          className="max-width-100"
        />
      </div>
      <p className="grey-70 mb-m">{t('empty_state')}</p>
      {canEdit && (
        <Button kind={Kind.SECONDARY} onClick={onAdd} className="w-100">
          {t('add_button')} +
        </Button>
      )}
    </CmsPage>
  )
}

export default EmptyState
